export const routes = {
  root: () => '/',
  overview: () => '/me',
  myTasks: () => '/me/tasks',
  myTasksThread: (threadId: string) => `/me/tasks?thread=${encodeURIComponent(threadId)}`,
  server: (guildId: string) => `/s/${guildId}`,
  channel: (guildId: string, channelId: string) => `/s/${guildId}/channel/${channelId}`,
  thread: (guildId: string, channelId: string, threadId: string) =>
    `/s/${guildId}/channel/${channelId}/thread/${threadId}`,
  dm: (dmChannelId: string) => `/dm/${dmChannelId}`,
  dmList: () => '/dm',
  agents: () => '/me/agents',
  agent: (agentId: string) => `/me/agents/${agentId}`,
  computers: () => '/me/computers',
  computer: (nodeId: string) => `/me/computers/${nodeId}`,
  invitations: (guildId: string) => `/s/${guildId}/invitations`,
  serverSettings: (guildId: string) => `/s/${guildId}/settings`,
  tasks: (guildId: string) => `/s/${guildId}/tasks`,
  tasksThread: (guildId: string, threadId: string) =>
    `/s/${guildId}/tasks?thread=${encodeURIComponent(threadId)}`,
  insights: (guildId: string) => `/s/${guildId}/insights`,
  members: (guildId: string) => `/s/${guildId}/members`,
  member: (guildId: string, memberId: string) => `/s/${guildId}/members/${memberId}`,
} as const;

export function isComputersRoute(pathname: string): boolean {
  return /^\/me\/computers(\/|$)/.test(pathname);
}
